import { SystemsState } from 'features/systems/systems-slice';
import { IdentifiedSystemEntryType } from 'types/error-log';

const addId = (ids: Set<string>, value: string | number | null | undefined) => {
  if (value !== null && value !== undefined) {
    ids.add(String(value));
  }
};

export function collectSelectedSystemIds(systems: SystemsState): Set<string> {
  const ids = new Set<string>();
  (systems.selectedSystems ?? []).forEach((system) => {
    addId(ids, system.id);
    addId(ids, system.uniqueId);
  });
  (systems.selectedDuctedSystems ?? []).forEach((system) => {
    addId(ids, system.id);
  });
  return ids;
}

export function isSelectedSystemEntry(
  entry: IdentifiedSystemEntryType,
  selectedIds: Set<string>
): boolean {
  if (entry.id !== undefined && entry.id !== null) {
    if (selectedIds.has(String(entry.id))) {
      return true;
    }
  }
  return entry.uniqueId !== undefined && selectedIds.has(entry.uniqueId);
}

function filterListsBySelection<T extends IdentifiedSystemEntryType>(
  lists: Record<string, T[]> | undefined,
  selectedIds: Set<string>
): Record<string, T[]> {
  return Object.fromEntries(
    Object.entries(lists ?? {}).map(([key, entries]) => [
      key,
      (entries ?? []).filter((entry) =>
        isSelectedSystemEntry(entry, selectedIds)
      )
    ])
  );
}

export function trimSystemsForSnapshot(systems: SystemsState): SystemsState {
  const selectedIds = collectSelectedSystemIds(systems);
  return {
    ...systems,
    systemsForNewOption: (systems.systemsForNewOption ?? []).filter((system) =>
      isSelectedSystemEntry(system, selectedIds)
    ),
    systemOptions: filterListsBySelection(systems.systemOptions, selectedIds),
    systemCombinationsValid: filterListsBySelection(
      systems.systemCombinationsValid,
      selectedIds
    ),
    systemCombinationsFull: filterListsBySelection(
      systems.systemCombinationsFull,
      selectedIds
    ),
    scenarioWinnersByConfig: filterListsBySelection(
      systems.scenarioWinnersByConfig,
      selectedIds
    )
  };
}
